module.exports = __webpack_public_path__ + "media/images/review/sample-photo3-9822f70892a68d0d2df5bdac12ed0881.jpg";